import { Extension, ReaderContext, WriterContext } from '@gltf-transform/core3';
import { CYNCLY_MESH_METADATA } from '../constants';
import { MeshMetadata } from './mesh-metadata';

const NAME = CYNCLY_MESH_METADATA;

interface MeshMetadataDef {
	castShadow: boolean | null;
	visibleToCamera: boolean | null;
}

export class CYNCLYMeshMetadata extends Extension {
	public readonly extensionName = NAME;
	public static readonly EXTENSION_NAME = NAME;

	/** Creates a new MeshMetadata property for use on a {@link Mesh}. */
	public createMeshMetadata(name = ''): MeshMetadata {
		return new MeshMetadata(this.document.getGraph(), name);
	}

	public read(context: ReaderContext): this {
		const jsonDoc = context.jsonDoc;

		jsonDoc.json.meshes!.forEach((meshDef, meshIndex) => {
			if (!meshDef.extensions || !meshDef.extensions[NAME]) return;
			const meshMetadataDef = meshDef.extensions[NAME] as MeshMetadataDef;
			const meshMetadata = this.createMeshMetadata();
			
			meshMetadata.setCastShadow(meshMetadataDef.castShadow);
			meshMetadata.setVisibleToCamera(meshMetadataDef.visibleToCamera);

			context.meshes[meshIndex].setExtension(NAME, meshMetadata);
		});

		return this;
	}

	public write(context: WriterContext): this {
		if (this.properties.size === 0) return this;

		this.document
			.getRoot()
			.listMeshes()
			.forEach((mesh) => {
				const meshMetadata = mesh.getExtension<MeshMetadata>(NAME);
				if (meshMetadata) {
					const meshMetadataDef = {} as MeshMetadataDef;

					if (meshMetadata.getCastShadow() != null) {
						meshMetadataDef.castShadow = meshMetadata.getCastShadow();
					}
					if (meshMetadata.getVisibleToCamera() != null) {
						meshMetadataDef.visibleToCamera = meshMetadata.getVisibleToCamera();
					}

					const meshIndex = context.meshIndexMap.get(mesh)!;
					const meshDef = context.jsonDoc.json.meshes![meshIndex];
					meshDef.extensions = meshDef.extensions || {};
					meshDef.extensions[NAME] = meshMetadataDef;
				}
			});

		return this;
	}
}
